export const PAY_ON_ACCOUNT_BUTTON_TEST_ID = 'payment.pay-on-account.button';
export const PAY_ON_TERM_BUTTON_TEST_ID = 'payment.pay-on-terms.button';
export const BANK_TRANSFER_OR_CHEQUE_BUTTON_TEST_ID = 'payment.bank-transfer-or-check.button';
export const MULTIPLE_CASH_OPTIONS_BUTTON_TEST_ID = 'payment.cash.button';
